<h2 *ngIf="data.isAssign" mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'title.assign_group_customer' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<h2 *ngIf="!data.isAssign" mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0px !important;">
    {{'title.remove_assign_group_customer' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>
<div style="max-height: 70vh; overflow-y: auto; overflow-x: hidden; padding-right: 0.5rem !important;">
    <div class="row" style="padding: 12px">
        <h5 *ngIf="data.isAssign">{{'title.group_customer_info' | translate}}(<span style="color: red;">*</span>)</h5>
        <h5 *ngIf="!data.isAssign">{{'title.select_remove_group' | translate}}(<span style="color: red;">*</span>)</h5>
        <div class="col-sm-12" style="padding: 0 !important;margin-bottom: 15px;">
            <div>
                <nz-input-group>
                    <input nz-input [(ngModel)]="inputGroupValue" (input)="onChangeGroupSignSearch($event)"
                        (focusOut)="inputGroupValue = inputGroupValue?.trim" [nzAutocomplete]="autoGroupSearching"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="{{'search_form.group_search_placeholder' | translate}}" id="inputGroup"
                        maxlength="200" nzServerSearch nzShowSearch nzAllowClear />
                    <nz-autocomplete #autoGroupSearching>
                        <nz-auto-option *ngFor="let group of filteredGroupOptions"
                            (selectionChange)="autocompleteGroupSelected($event, group)" [nzValue]="''">{{group.name}}
                        </nz-auto-option>
                        <nz-auto-option *ngIf="filteredGroupOptions.length == 0 && inputGroupValue" nzDisabled
                            nzCustomContent>
                            <div style="padding: 6px; text-align: center; color: black">{{'messages.data_not_found' |
                                translate}}</div>
                        </nz-auto-option>
                        <nz-auto-option *ngIf="filteredGroupOptions.length == 0 && inputGroupValue" nzDisabled
                            nzCustomContent></nz-auto-option>
                    </nz-autocomplete>
                </nz-input-group>
            </div>
        </div>
        <small *ngIf="groupRequired && selectedGroup.length == 0" class="text-danger">{{'messages.group_customer_required' | translate}}</small>
        <div *ngIf="selectedGroup.length > 0" class="col-sm-12"
            style="padding-right: 2rem !important; margin-bottom: 15px;">
            <div class="d-flex flex-wrap flex-gap-chip">
                <div class="chip" *ngFor="let group of selectedGroup; let i = index">
                    {{ group.name }}
                    <span class="material-icons" (click)="deleteGroup(i)">
                        cancel
                    </span>
                </div>
            </div>
        </div>

    </div>
    <div class="row pb-2">
        <div class="col-sm-8 d-flex align-items-center">
            <h5>{{'title.customer_list' | translate}}<span style="color: red;">*</span>({{dataCount}})</h5>
        </div>
        <div class="col-sm-4" style="padding-right: 12px !important;">
            <i class="fa fa-filter pull-right" aria-hidden="true" (click)="openFilter()"
                style="margin-right: 7px; color: rgb(238 0 51); font-size: 18px; cursor: pointer;"
                matTooltip="{{ 'button.filter' | translate }}"></i>
        </div>
        <small style="margin-left: 12px;" *ngIf="selectedCustomer.length == 0" class="text-danger">{{'messages.list_customer_required' | translate}}</small>
    </div>
    <div class="mat-table-container">
        <mat-table [dataSource]="dataSource" width="100%">
            <!-- STT -->
            <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef
                    class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                    {{'enterprise_customer_management.table_headers.No' | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let element"
                [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                    class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                    {{dataSource.filteredData.indexOf(element) + 1}}</mat-cell>
            </ng-container>

            <!-- Tên khách hàng -->
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef style="width: 25%;" class="mat-cell-non-boder-right-bottom">
                    {{'enterprise_customer_management.group_customer_header.customer_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" matTooltip="{{element.name}}" matTooltipPosition="below"
                [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                    style="width: 25%;" class="mat-cell-non-boder-right-bottom">
                    <span class="fix-width">{{element.name}}</span>
                </mat-cell>
            </ng-container>

            <!-- nhóm khách hàng -->
            <ng-container matColumnDef="group">
                <mat-header-cell *matHeaderCellDef style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                  {{'enterprise_customer_management.table_headers.group_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" matTooltip="{{element.customerGroupNames}}" matTooltipPosition="below"
                [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                  style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                  <span class="fix-width">{{element.customerGroupNames}}</span>
                </mat-cell>
              </ng-container>

            <!-- Mô tả -->
            <ng-container matColumnDef="certificateNo">
                <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                    {{'enterprise_customer_management.group_customer_header.certificate_no' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" style="max-width: 20%;" class="mat-cell-non-boder-right-bottom"
                [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                    matTooltip="{{element.certificateNo ? element.certificateNo : ''}}">
                    <span class="fix-width">{{element.certificateNo}}
                    </span>
                </mat-cell>
            </ng-container>

            <!-- Mô tả -->
            <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                    {{'enterprise_customer_management.group_customer_header.email' | translate}}

                </mat-header-cell>
                <mat-cell *matCellDef="let element" style="max-width: 20%;" class="mat-cell-non-boder-right-bottom"
                [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                    matTooltip="{{element.email ? element.email : ''}}">
                    <span class="fix-width">{{element.email}}
                    </span>
                </mat-cell>
            </ng-container>

            <!-- Tác động -->
            <!-- Setting Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom"
                    style="max-width: 100px;">
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-bottom"
                [ngClass]="{'backgroud-odd' : checkIndexOfElement(element), 'backgroud-even': !checkIndexOfElement(element)}"
                    style="max-width: 100px;">
                    <button mat-icon-button (click)="onClickIconDelete(element)"
                        [disabled]="commonService.getIsLockedEnterprise()">
                        <i class="fa fa-trash" aria-hidden="true"
                            [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                            matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                    </button>
                </mat-cell>
            </ng-container>

            <!-- filter -->
            <!-- STT -->
            <ng-container matColumnDef="stt">
                <mat-header-cell *matHeaderCellDef
                    class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                </mat-header-cell>
            </ng-container>

            <!-- Tên khách hàng -->
            <ng-container matColumnDef="filterName">
                <mat-header-cell *matHeaderCellDef style="width: 25%;" class="mat-cell-non-boder-right-bottom">
                    <input style="width: 100%;" nz-input id="name" (focusout)="filterForm.name = filterForm.name.trim()"
                        (change)="getDataCustomer()" [(ngModel)]="filterForm.name"
                        [placeholder]="'enterprise_customer_management.filter.customer_name' | translate">
                </mat-header-cell>
            </ng-container>

            <!-- Tên nhóm khách hàng -->
            <ng-container matColumnDef="filterGroupName">
                <mat-header-cell *matHeaderCellDef style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                    <input style="width: 100%;" nz-input id="groupName" (focusout)="filterForm.groupName = filterForm.groupName.trim()"
                        (change)="getDataCustomer()" [(ngModel)]="filterForm.groupName"
                        [placeholder]="'enterprise_customer_management.filter.name' | translate">
                </mat-header-cell>
            </ng-container>

            <!-- Số giấy tờ -->
            <ng-container matColumnDef="filterCertificate">
                <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                    <input style="width: 100%;" nz-input id="certificateNo"
                        (focusout)="filterForm.certificateNo = filterForm.certificateNo.trim()"
                        (change)="getDataCustomer()" [(ngModel)]="filterForm.certificateNo"
                        [placeholder]="'enterprise_customer_management.filter.certificateNo' | translate">
                </mat-header-cell>
            </ng-container>

            <!-- email -->
            <ng-container matColumnDef="filterEmail">
                <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                    <input style="width: 100%;" nz-input id="email"
                        (focusout)="filterForm.email = filterForm.email.trim()" (change)="getDataCustomer()"
                        [(ngModel)]="filterForm.email"
                        [placeholder]="'enterprise_customer_management.filter.email' | translate">
                </mat-header-cell>
            </ng-container>

            <!-- Tác động -->
            <!-- Setting Column -->
            <ng-container matColumnDef="actionFilter" class="mat-column-symbol">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom"
                    style="max-width: 100px;">
                </mat-header-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-header-row style="background: white !important;" [ngClass]="isShowFilter ? '' : 'd-none'"
                *matHeaderRowDef="filterRow"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
    <div class="py-4" *ngIf="error">
        <div class="card">
            <p class="card-body text-danger" style="white-space: pre-wrap; padding-bottom: 0;">{{error}}</p>
        </div>
    </div>
</div>
<div mat-dialog-actions class="justify-content-center">
    <!--build icon, set default cancel-->
    <button mat-stroked-button color="primary" type="button" (click)="onClose()" cdkFocusInitial>
        <mat-icon class="mr-0">cancel</mat-icon>{{'button.cancel' | translate}}
    </button>
    <button *ngIf="data.isAssign" class="ml-2" mat-raised-button color="primary" (click)="onAssign()"
        [mat-dialog-close]="true" [disabled]="!this.selectedCustomer || this.selectedCustomer.length == 0 || this.selectedGroup.length == 0">
        <mat-icon class="mr-0">save</mat-icon>{{'button.assign_group_dialog' | translate}}
    </button>
    <button *ngIf="!data.isAssign" class="ml-2" mat-raised-button color="primary" (click)="onRemoveAssign()"
        [mat-dialog-close]="true" [disabled]="!this.selectedCustomer || this.selectedCustomer.length == 0 || this.selectedGroup.length == 0">
        <mat-icon class="mr-0">save</mat-icon>{{'button.remove_assign_group_dialog' | translate}}
    </button>
</div>